<template>
  <div class="all-order">
    <div class="content-wrapper">
      <div class="filter-wrapper">
        <span class="time-text">{{$t("m.ord_a_search_date")}}</span>
        <el-date-picker
          class="timepicker"
          v-model="date"
          @change="searchByTime"
          type="daterange"
          range-separator="--"
          :start-placeholder="$t('m.ord_a_search_startdate')"
          :end-placeholder="$t('m.ord_a_search_enddate')"
          unlink-panels
          size="small">
        </el-date-picker>
        <div class="phone-wrapper">
          <input type="text"
                 class="input-phone"
                 maxlength="11"
                 :value="integer"
                 @keyup="integerChange"
                 :placeholder="$t('m.ord_a_search_phone')">
          <button class="search" @click="searchByPhone"></button>
        </div>
      </div>
      <p class="no-result" v-if="isEmpty(orderList)">{{$t("m.ord_a_noresult")}}</p>
      <table class="table" v-if="!isEmpty(orderList)">
        <tr class="order-brief">
          <th class="black">
            {{$t("m.ord_a_registration_time")}}
          </th>
          <th class="border">
            {{$t("m.ord_a_name")}}
          </th>
          <th class="border">
            {{$t("m.ord_a_phone")}}
          </th>
          <th class="border">
            {{$t("m.ord_a_course")}}
          </th>
          <th class="border">
            {{$t("m.ord_a_class")}}
          </th>
          <th>
            {{$t("m.ord_a_pay")}}
          </th>
        </tr>
        <template v-for="(item,index) in orderList">
          <tr class="order-brief">
            <td @click="showItem(item, index)">
              <span class="arrow" :class="{show:item.show}"></span>{{item.addtime.substring(0, 16)}}
            </td>
            <td>
              <div>{{item.username}}</div>
            </td>
            <td>
              {{item.phone}}
            </td>
            <td :title="decodeURIComponent(item.lessonname)">
              《{{decodeURIComponent(item.lessonname)}}》
            </td>
            <td>
              {{decodeURIComponent(item.classmodename)}}/{{decodeURIComponent(item.classname)}}
            </td>
            <td>
              ¥{{item.paymoney}}
            </td>
          </tr>

          <tr class="order-info" v-if="item.show">

            <td class="td" colspan="6">
              <!--<slide-up-down ref="slideupdown" :active="item.show" :duration="500">-->
                <div class="left">
                  <p>{{$t("m.ord_a_details")}}</p>
                  <p>{{$t("m.ord_a_order_number")}}{{item.out_trade_no}}</p>
                  <button @click="showCancel(item)">{{$t("m.ord_a_order_cancel")}}</button>
                </div>
                <div class="right">
                  <p>{{$t("m.ord_a_opentime")}}{{item.startdate.substring(0, 16)}}</p>
                  <p>{{$t("m.ord_a_totalnumber")}}{{item.totalnumber}}{{$t("m.ord_a_totalnumber2")}}</p>
                </div>
              <!--</slide-up-down>-->
            </td>

          </tr>

        </template>
      </table>
      <template v-if="!isEmpty(orderList)">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page.sync="currentPage"
          @current-change="handleCurrentChange"
          :page-size="10"
          :total="totalPage">
        </el-pagination>
      </template>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import {saveLocal, loadLocal} from 'common/js/store.js';
  import Vue from 'vue';

  export default {
    data() {
      return {
        id: (() => loadLocal('id', false))(),
        schoolNow: (() => loadLocal('schoolNow', false))(),
        date: [],
        inputInteger: '',
        oldInputInteger: '',
        currentPage: 1,
        totalPage: 1,
        orderList: [],
      }
    },
    methods: {
      isEmpty(obj) {
        for (let i in obj) {
          return !1;
        }
        return !0;
      },
      //当用户更改时间时，通过时间查找
      searchByTime() {
        //清空手机号码
        this.inputInteger = '';
        this.oldInputInteger = '';
        let params = this.conputeXHRParams(1);
        this.currentPage = 1;
        this.QueryClassUser(params);

      },
      //当用户输入手机号码时，通过手机号码查找
      searchByPhone() {
        let lang = loadLocal('language', false);
        if (this.integer.length !== 11 || this.integer == '') {
          if (lang === false || lang === 'ch') {
            this.$message({
              message: '请输入正确的手机号码',
//            message: "{{$t('m.ord_a_search_startdate')}}",
              type: 'waring'
            });
            return;
          } else {
            this.$message({
              message: 'Please input the right phone number',
              type: 'waring'
            });
            return;
          }

        }
        this.date = [];
        this.oldInputInteger = this.integer;
        let params = this.conputeXHRParams(1);
        this.currentPage = 1;
        this.QueryClassUser(params);
      },
      //改变页码时
      handleCurrentChange(val) {
        let params = this.conputeXHRParams(val);
        this.QueryClassUser(params);
        this.$forceUpdate();
      },
      integerChange(e) {
        this.inputInteger = e.target.value;
        this.$forceUpdate()  // 这里必须有
      },
      showItem(item, index) {
        item.show = !item.show;
//        Vue.set(this.orderList[index], 'show', true);
        this.$forceUpdate();
      },
      //显示是否取消
      showCancel(item) {
        let lang = loadLocal('language', false);
        if (lang === false || lang === 'ch') {
          this.$confirm('确认取消订单申请吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
          }).then(() => {
            this.CancelOrderClass(item);
          }).catch(() => {
          });
        } else {
          this.$confirm('Are you sure to cancel this order?', 'Hint', {
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Cancel',
          }).then(() => {
            this.CancelOrderClass(item);
          }).catch(() => {
          });
        }

      },
      CancelOrderClass(item) {
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'Unipay',
            a: 'CancelOrderClass',
            id: this.id,
            rid: item.rid,
            classid: item.classid,
            orderuserid: item.userid,
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          this.$alert(response.msg, '提示', {
            confirmButtonText: '确定',
          });
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        });
      },
      //根据用户当前有哪些值，计算XHR请求的参数
      conputeXHRParams(pageNumber) {
        //当前的逻辑为根据时间请求和手机号码请求是不关联的，因此通过时间请求时，会清空手机号码，根据手机号码请求时，会清空时间
        let params = {
          c: 'ClassUser',
          a: 'QueryClassUser',
          id: this.id,                //sessionid
          rid: this.schoolNow.rid,
          pageno: pageNumber,
          pagesize: 10,
          count: 1
        };
        //当时间不为空时
//        if (this.isEmpty(this.date) && this.oldInputInteger !== '') {
//          return params;
//        }
        if (!this.isEmpty(this.date)) {
          let startDate = this.date[0];
          let endDate = this.date[1];
          let start = startDate.getFullYear() + '-' + (startDate.getMonth() + 1) + '-' + startDate.getDate();
          let end = endDate.getFullYear() + '-' + (endDate.getMonth() + 1) + '-' + endDate.getDate();
          params.enrollstartdate = start + ' 00:00';
//          let interval = ( Math.abs(Date.parse(end) - Date.parse(start)) ) / 1000 / 60 / 60 / 24;
          params.enrollenddate = end + ' 23:59';
        }
        //如果手机号码不为空(另需注意computed中的integer不需要带上括号，因为integer不是function)
        if (this.oldInputInteger !== '') {
          this.inputInteger = this.oldInputInteger;
          params.phone = this.oldInputInteger;
        }
        return params;
      },
      QueryClassUser(params) {
        this.orderList = [];
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: params
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            this.orderList = response.list;
            this.orderList.forEach(function (ele) {
              ele.show = false;
            });
            this.totalPage = response.recordcount;
            this.$forceUpdate();
          }
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        });
      }
    },
    computed: {
      integer() {
        let result = this.inputInteger.replace(/[^\d]/g, '').replace(/^0/g, "");
        return result;
      },
    },
    created() {
      let params = this.conputeXHRParams(1);
      this.QueryClassUser(params);
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .all-order
    width: 100%
    height: 100%
    background: #f2f2f2
    font-size: 0
    overflow auto
    .content-wrapper
      margin: 111px 20px 20px 180px
      width: 1166px
      .filter-wrapper
        margin-bottom: 20px
        padding-left: 10px
        height: 60px
        width: 100%
        font-size: 0
        background #fff
        box-sizing border-box
        .time-text
          display: inline-block
          width: 105px
          height: 60px
          line-height: 60px
          font-size: 14px
          color: #000
          vert-align top
        .phone-wrapper
          float: right
          margin: 13px 10px 0 0
          width: 200px
          height: 32px
          border: 1px solid #e4e4e4
          border-radius 4px
          overflow hidden
          .input-phone
            display inline-block
            width: 160px
            height: 32px
            padding-left: 10px
            font-size: 14px
            color: #000000
            background #fff
            box-sizing border-box
            vertical-align top
            &::-webkit-input-placeholder
              color: #999

          .search
            display inline-block
            width: 40px
            height: 32px
            background #fafafa url(./search.png) no-repeat center / 20px 20px
      .no-result
        font-size: 14px
        color: #000000
        text-align: center
      .table
        width: 1164px
        background: #ffffff
        text-align: center
        font-size: 0
        table-layout: fixed
        .order-brief
          border-bottom: 1px solid #e4e4e4
          &:last-child
            border: none
          th
            height: 40px
            line-height: 40px
            width: 194px
            font-size: 14px
            color: #999
            box-sizing: border-box
            &:first-child
              width: 244px
              border-right: 1px solid #e4e4e4
            &:last-child
              width: 144px
            &.black
              color: #000
            &.border
              position: relative
              &::after
                content: ''
                position: absolute
                top: 10px
                right: 0
                width: 0
                height: 20px
                border-right: 1px solid #e4e4e4

          td
            height: 50px
            line-height: 50px
            font-size: 14px
            color: #333
            overflow: hidden
            text-overflow: ellipsis
            white-space: nowrap
            box-sizing: border-box
            &:first-child
              text-align center
              color: #336699
              border-right: 1px solid #e4e4e4
              position relative
              cursor: pointer
              .arrow
                position absolute
                left: 24px
                top: 18px
                display: inline-block
                width: 8px
                height: 8px
                border-left: 1px solid #333
                border-bottom: 1px solid #333
                transform: rotate(-45deg)
                transition-duration 300ms
                &.show
                  transform: rotate(135deg)
                  top: 21px
        .order-info
          height: 144px
          background: #fafafa
          border-bottom: 1px solid #e4e4e4
          box-sizing: border-box
          /*&.fade-enter-active, &.fade-leave-active*/
          /*transition: all 0.5s ease*/
          /*&.fade-enter, &.fade-leave-active*/
          /*opacity: 0*/
          .td
            padding: 20px 35px
            text-align: left
            .left
              display: table-cell
              padding: 0
              width: 480px
              p
                margin-bottom: 10px
                font-size: 13px
                color: #999999
                line-height: 18px
              button
                margin-top: 16px
                height: 30px
                line-height: 30px
                width: 118px
                text-align: center
                color: #3399ff
                border: 1px solid #3399ff
                border-radius: 4px
            .right
              display: table-cell
              width: 480px
              height: 104px
              p
                line-height: 26px
                font-size: 14px
                color: #999
</style>



// WEBPACK FOOTER //
// src/page/order/allorders/AllOrders.vue